import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { OPEN_WITH_FAIRE_OFFERED_TERMS } from "@faire/web-api--source/indigofair/settings/OPEN_WITH_FAIRE_OFFERED_TERMS";

export const getSettingOpenWithFaireOfferedTerms = () =>
  getSettingValueWithoutAssignment(OPEN_WITH_FAIRE_OFFERED_TERMS, {});
